import React from 'react';
import { Link } from 'react-router-dom';
import { EyeIcon, DownloadIcon, TrashIcon, CheckCircleIcon } from 'lucide-react';
interface Document {
  id: string;
  type: string;
  fileName: string;
  fileSize: number;
  uploadedAt: string;
  verified: boolean;
  aiAnalysis: any;
}
interface DocumentTableProps {
  documents: Document[];
  onPreview: (document: Document) => void;
  onDelete: (documentId: string) => void;
}
export function DocumentTable({
  documents,
  onPreview,
  onDelete
}: DocumentTableProps) {
  const formatFileSize = (sizeInKB: number) => {
    if (sizeInKB < 1000) {
      return `${sizeInKB.toFixed(2)} KB`;
    } else {
      return `${(sizeInKB / 1024).toFixed(2)} MB`;
    }
  };
  const formatUploadTime = (timestamp: string) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diffInMinutes = Math.floor((now.getTime() - date.getTime()) / (1000 * 60));
    if (diffInMinutes < 1) {
      return 'just now';
    } else if (diffInMinutes < 60) {
      return `${diffInMinutes} minute${diffInMinutes === 1 ? '' : 's'} ago`;
    } else if (diffInMinutes < 1440) {
      const hours = Math.floor(diffInMinutes / 60);
      return `${hours} hour${hours === 1 ? '' : 's'} ago`;
    } else {
      return date.toLocaleDateString();
    }
  };
  return <div className="overflow-x-auto" data-id="element-238">
      <table className="min-w-full divide-y divide-neutral-200" data-id="element-239">
        <thead data-id="element-240">
          <tr data-id="element-241">
            <th className="px-4 py-3 text-left text-sm font-medium text-neutral-500 uppercase tracking-wider" data-id="element-242">
              Type
            </th>
            <th className="px-4 py-3 text-left text-sm font-medium text-neutral-500 uppercase tracking-wider" data-id="element-243">
              File Name
            </th>
            <th className="px-4 py-3 text-left text-sm font-medium text-neutral-500 uppercase tracking-wider" data-id="element-244">
              Size
            </th>
            <th className="px-4 py-3 text-left text-sm font-medium text-neutral-500 uppercase tracking-wider" data-id="element-245">
              Uploaded
            </th>
            <th className="px-4 py-3 text-right text-sm font-medium text-neutral-500 uppercase tracking-wider" data-id="element-246">
              Actions
            </th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-neutral-200" data-id="element-247">
          {documents.map(document => <tr key={document.id} className="hover:bg-neutral-50" data-id="element-248">
              <td className="px-4 py-4 whitespace-nowrap" data-id="element-249">
                <div className="flex items-center" data-id="element-250">
                  {document.verified && <CheckCircleIcon className="h-5 w-5 text-success-500 mr-2" data-id="element-251" />}
                  <span className="text-sm text-neutral-900" data-id="element-252">
                    {document.type}
                  </span>
                </div>
              </td>
              <td className="px-4 py-4 whitespace-nowrap" data-id="element-253">
                <Link to={`/applications/documents/${document.id}`} className="text-sm text-primary-600 hover:text-primary-800 font-medium" data-id="element-254">
                  {document.fileName}
                </Link>
              </td>
              <td className="px-4 py-4 whitespace-nowrap" data-id="element-255">
                <span className="text-sm text-neutral-500" data-id="element-256">
                  {formatFileSize(document.fileSize)}
                </span>
              </td>
              <td className="px-4 py-4 whitespace-nowrap" data-id="element-257">
                <span className="text-sm text-neutral-500" data-id="element-258">
                  {formatUploadTime(document.uploadedAt)}
                </span>
              </td>
              <td className="px-4 py-4 whitespace-nowrap text-right" data-id="element-259">
                <div className="flex justify-end space-x-2" data-id="element-260">
                  <Link to={`/applications/documents/${document.id}`} className="text-neutral-400 hover:text-neutral-600" title="View" data-id="element-261">
                    <EyeIcon className="h-5 w-5" data-id="element-262" />
                  </Link>
                  <button onClick={() => {}} className="text-neutral-400 hover:text-neutral-600" title="Download" data-id="element-263">
                    <DownloadIcon className="h-5 w-5" data-id="element-264" />
                  </button>
                  <button onClick={() => onDelete(document.id)} className="text-neutral-400 hover:text-danger-600" title="Delete" data-id="element-265">
                    <TrashIcon className="h-5 w-5" data-id="element-266" />
                  </button>
                </div>
              </td>
            </tr>)}
        </tbody>
      </table>
    </div>;
}